<template>
    <div class="hub-spot-contact-form-container">
        <div
            class="loading-ellipsis"
            v-if="loading"
            role="alert"
            aria-live="polite"
            aria-label="Loading contact form"
        />
        <div
            v-else
            :id="id"
            class="hub-spot-contact-form"
        />
    </div>
</template>

<script>

    export default {
        name: 'hub-spot-contact-form',

        props: {
            id: {
                type: String,
                required: true,
            },
        },

        async mounted() {
            this.loading = true;

            const url = 'https://js-eu1.hsforms.net/forms/embed/v2.js';

            if (!this.scriptExists(url)) {
                const script = document.createElement('script')
                script.setAttribute('src', url)
                document.head.appendChild(script)
            }

            this.isScriptLoaded(this.createHubSpotForm);
        },

        data() {
            return {
                loading: false,
            };
        },

        methods: {
            /**
             * Check if script already exists.
             * 
             * @param {string} url
             */
            scriptExists(url) {
                return document.querySelectorAll(`script[src="${url}"]`).length > 0;
            },

            /**
             * Check to see if the hubspot script is loaded. If it is then invoke the callback.
             * If not, then check again in 100ms
             *
             * @param {Function} callback
             */
            isScriptLoaded(callback) {
                const interval = setInterval(() => {
                    if (window.hbspt) {
                        clearInterval(interval)
                        callback()
                        this.loading = false;
                    }
                }, 100);
            },

            /**
             * Create the hubspot form
             * Handle redirect after form submission
             */
            createHubSpotForm() {
                window.hbspt.forms.create({
                    region: 'eu1',
                    portalId: '143563801',
                    formId: '0a4a5374-1ddc-4f7d-97b7-253fd1559f5e',
                    target: `#${ this.id }`,

                    onFormError: (error) => {
                        console.log(error);
                    },
                });
            }
        }
    }
</script>
<style lang="less" scoped>
    .hub-spot-contact-form-container {
        width: 100%;
    }
    .loading-ellipsis { // https://css-tricks.com/single-element-loaders-the-dots/
        margin-left: 15px;
        display: inline-block;
        width: 10px;
        aspect-ratio: 1;
        border-radius: 50%;
        animation: loading 1s infinite linear alternate;
    }
    @keyframes loading {
        0% {
            box-shadow: 15px 0 #000000, -15px 0 #00000022;
            background: #000000
        }
        33% {
            box-shadow: 15px 0 #000000, -15px 0 #00000022;
            background: #00000022
        }
        66% {
            box-shadow: 15px 0 #00000022, -15px 0 #000000;
            background: #00000022
        }
        100% {
            box-shadow: 15px 0 #00000022, -15px 0 #000000;
            background: #000000
        }
    }
</style>